import { render, staticRenderFns } from "./amazonProductLibrary.vue?vue&type=template&id=db22f266&scoped=true"
import script from "./amazonProductLibrary.vue?vue&type=script&lang=js"
export * from "./amazonProductLibrary.vue?vue&type=script&lang=js"
import style0 from "./amazonProductLibrary.vue?vue&type=style&index=0&id=db22f266&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db22f266",
  null
  
)

export default component.exports